import Video from '~/components/Video';
import { VideoUrlInterface } from '~/payload-types';

export type VideoUrlBlockProps = VideoUrlInterface & {};

const VideoUrlBlock = (props: VideoUrlBlockProps) => {
  return (
    <Video
      src={props.src}
      controls={props.controls!}
      loop={props.loop!}
      autoPlay={props.autoPlay!}
      muted={props.muted!}
    ></Video>
  );
};

export default VideoUrlBlock;
